import { useField } from "formik";
import React from "react";

import { YesNoChoice } from "@gamedev-web/one-gaming-crm";
import { useStrings } from "../../localization/localizationHelpers";
import { FieldHeaderProps } from "../FieldHeader";
import { RadioOption, RadioOptionsField } from "../RadioOptionsField";
import { TextField } from "../TextField";

type BaseRadioOptionWithDetailsProps = Readonly<{
  name: string;
  detailsFieldName: string;
  detailsTitle: string;
  isSaving: boolean;
  maxLengthsByFieldName?: Record<string, number>;
}> &
  FieldHeaderProps;

export type YesNoRadioOptionWithDetailsProps = Readonly<{
  detailsTriggerValue: YesNoChoice;
}> &
  BaseRadioOptionWithDetailsProps;

export type RadioOptionWithDetailsProps = Readonly<{
  options: RadioOption[];
  detailsTriggerValuesArray: (string | number)[];
}> &
  BaseRadioOptionWithDetailsProps;

export const RadioOptionWithDetails = (props: RadioOptionWithDetailsProps) => {
  const {
    detailsFieldName,
    detailsTitle,
    detailsTriggerValuesArray,
    isSaving,
    maxLengthsByFieldName,
  } = props;
  const [field] = useField(props);
  const triggerValueSelected = detailsTriggerValuesArray.some(
    value => value.toString() === field.value
  );
  return (
    <>
      <RadioOptionsField {...props} />
      {triggerValueSelected && (
        <TextField
          name={detailsFieldName}
          title={detailsTitle}
          isRequiredField={true}
          isSaving={isSaving}
          maxLengthsByFieldName={maxLengthsByFieldName}
        />
      )}
    </>
  );
};

export const YesNoRadioOptionWithDetails = (props: YesNoRadioOptionWithDetailsProps) => {
  const [yes, no] = useStrings("yes", "no");
  return (
    <RadioOptionWithDetails
      {...props}
      options={[
        {
          value: YesNoChoice.yes,
          label: yes,
        },
        {
          value: YesNoChoice.no,
          label: no,
        },
      ]}
      detailsTriggerValuesArray={[props.detailsTriggerValue]}
    />
  );
};
